export default __webpack_public_path__ + "static/media/stock2.c9c20f3c.jpg";